// NewZealandPRPage.js
import React from 'react';
import PRHero from '../components/PermanentResidency/NewZealand/PRHero';
import WhyNewZealandPR from '../components/PermanentResidency/NewZealand/WhyNewZealandPR';
import PRPathways from '../components/PermanentResidency/NewZealand/PRPathways';
import EligibilityRequirements from '../components/PermanentResidency/NewZealand/EligibilityRequirements';
import ProcessTimeline from '../components/PermanentResidency/NewZealand/ProcessTimeline';
import PRPricing from '../components/PermanentResidency/NewZealand/PRPricing';
import PRFAQSection from '../components/PermanentResidency/NewZealand/PRFAQSection';
import PRCTASection from '../components/PermanentResidency/NewZealand/PRCTASection';

const NewZealandPRPage = () => {
  return (
    <div>
      <PRHero />
      <WhyNewZealandPR />
      <PRPathways />
      <EligibilityRequirements />
      <ProcessTimeline />
      <PRPricing />
      <PRFAQSection />
      <PRCTASection />
    </div>
  );
};

export default NewZealandPRPage;
